import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center">
        <div className="text-center">
          <div className="spinner w-10 h-10 mx-auto mb-4" />
          <p className="text-gray-400 font-mono text-sm">Authenticating...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (requiredRole && userProfile?.role !== requiredRole) {
    const roleRoutes = { citizen: '/citizen', responder: '/responder', admin: '/admin' };
    return <Navigate to={roleRoutes[userProfile?.role] || '/'} replace />;
  }

  return children;
}
